import gql from "graphql-tag";
import CompanyIssuerFields from "lib/graphql/fragments/CompanyIssuerFields";

export default gql`
  query CompanyIssuers(
    $input: [CompanyIssuerSearchRefInput!]!
    $descriptionLanguage: ISO6391LanguageCode
    $descriptionLanguages: [ISO6391LanguageCode!] = ["en", "pt"]
  ) {
    companyIssuers(input: $input) {
      _id
      ...CompanyIssuerFields
      description(language: $descriptionLanguage)
      descriptionTranslations(languages: $descriptionLanguages) {
        _id
        objectId
        language
        textContent
      }
    }
  }

  ${CompanyIssuerFields}
`;
